import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const TrackCard = ({ number, name, page }) => (
    <div className="link-visited">
        <Link
            //  style={{ textDecoration: "none" }}
            to={`${page || "/track"}`}
            rel="noreferrer">
            <div className="card-style">
                <h1>
                    <span
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "30px",
                            color: "#5D5CFF",
                        }}>
                        {number}
                    </span>
                </h1>

                <h1
                    style={{
                        fontFamily: "Poppins",
                        fontStyle: "normal",
                        fontWeight: "500",
                        fontSize: "15px",
                        lineHeight: "22px",
                        /* identical to box height */

                        letterSpacing: "0.02em",
                        textTransform: "uppercase",

                        color: "#595F7D",
                    }}>
                    {name}
                </h1>
            </div>
        </Link>
    </div>
);

TrackCard.propTypes = {
    number: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    page: PropTypes.string,
};

export default TrackCard;
